// src/client/components/projects/ProjectDetailHeader.tsx
import { Button } from '@/client/components/ui/button';
import { ProjectIcon } from './ProjectIcon';
import { StatusBadge } from './StatusBadge';
import type { RouterOutputs } from '@/client/utils/trpc';

type Project = RouterOutputs['projects']['byId'];

interface Props {
  project: Project;
  isAdmin: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export function ProjectDetailHeader({ project, isAdmin, onEdit, onDelete }: Props) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex min-w-0 items-start gap-4">
        <ProjectIcon name={project.name} size={48} />
        <div>
          <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
            {project.client_name ?? '—'}
          </p>
          <h1 className="break-words text-xl font-semibold sm:text-2xl">{project.name}</h1>
          {project.description && (
            <p className="mt-1 line-clamp-2 max-w-2xl text-sm text-muted-foreground">
              {project.description}
            </p>
          )}
          <div className="mt-2">
            <StatusBadge status={project.status} />
          </div>
        </div>
      </div>
      {isAdmin && (
        <div className="flex shrink-0 flex-wrap gap-2">
          <Button variant="outline" size="sm" onClick={onEdit}>
            Edit
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="text-destructive hover:text-destructive"
            onClick={onDelete}
          >
            Delete
          </Button>
        </div>
      )}
    </div>
  );
}
